// ============================================================================
// Steadfastly - Date and Formatting Utilities
// ============================================================================

export function formatDate(d) { 
  return d ? new Date(d).toLocaleDateString("en-US", { 
    month: "short", 
    day: "numeric", 
    year: "numeric" 
  }) : "—"; 
}

export function formatDateTime(d) { 
  return d ? new Date(d).toLocaleString("en-US", { 
    month: "short", 
    day: "numeric", 
    hour: "numeric", 
    minute: "2-digit" 
  }) : "—"; 
}

export function firstOfMonth(d) { 
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1))
    .toISOString()
    .slice(0, 10); 
}

export async function computeSha256Hex(arrayBuffer) {
  const hashBuffer = await crypto.subtle.digest("SHA-256", arrayBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
}
